module.exports = {
      id: "android-small-usage",
      viewBox: "0 0 512 512",
      url: "/" + "sprite-d3510a915c790cce9510dd41eb326371.svg#android-small",
      toString: function () {
        return this.url;
      }
    }